import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import Section from "@/components/wida/Section";
import Row from "@/components/wida/Row";
import Icon from "@/components/wida/Icon";

import Datas from "@/datas"
import Hover from "@/components/wida/Hover";
const { projects } = Datas

export default function Projects() {
    return <Section id="projects">
        <div className="text-center">
            <h1 className="text-4xl font-bold leading-tight">My Projects</h1>
            <p className="text-muted-foreground">Stuff I do / did in my free time or I was commisoned to do.</p>
            <Row className="mt-3">
                {projects.length == 0 ? "Coming Soon..." : projects.map((x, i) =>
                    <Card className="w-69 h-69 m-10 flex flex-col gap-3" key={i}>
                        <CardHeader>
                            <CardTitle className="text-xl">{x.name}</CardTitle>
                            <CardDescription><Row>{x.techs.map((x, j) =>
                                <Hover key={j} description={x.name}><Icon path={x.icon} color="#71717a" clickable={false} className={`w-4 h-4 ${(j != 0) && "ml-2"}`}></Icon></Hover>
                            )}</Row></CardDescription>
                        </CardHeader>
                        <CardContent className="flex-1 text-left text-[18px]">{x.description}</CardContent>
                        <CardFooter className="mt-auto">
                            <Row className="mt-2">{x.links.map((x, j) => 
                                <Hover key={j} description={x.tech.name}><Icon path={x.tech.icon} link={x.link} className={`w-6 h-6 ${(j != 0) && "ml-2"}`}></Icon></Hover>
                            )}</Row>
                        </CardFooter>
                    </Card>
                )}
            </Row>
            {projects.length != 0 ? <p className="text-2xl">And more...</p> : ""}
        </div>
    </Section>
}